import { useState, useMemo, useEffect } from 'react';
import { map, compact, get } from 'lodash';
import moment from 'moment';
import { LiveEventType } from 'store/pages/loaders/loader-types';
import formatDisplayRunTime from 'utils/format-display-run-time';
import requester from 'utils/requester';
import api from 'config/api';

const useMetadata = (object, videoTarget) => {
  const [currentProgram, setCurrentProgram] = useState<LiveEventType>(null);

  const result = useMemo(() => {
    if (!object || !videoTarget) return { title: '', description: '' };
    // hack for channel
    const vastGenre = get(object.genres, ['0', 'name'], null);
    const vastRating = get(object, 'mpaa', null);
    const objectTitle = object.name;

    if (object.type === 'channel') {
      const title = currentProgram?.name || object.name;
      const programTime =
        currentProgram &&
        `${moment(currentProgram.start_time).format('HH:mm')} - ${moment(
          currentProgram.end_time,
        ).format('HH:mm')} / `;
      const description = programTime ? `${programTime} ${object.name}` : null;

      return { title, description, vastGenre, vastRating, objectTitle };
    }
    const title = videoTarget.name;
    const runTime = formatDisplayRunTime(videoTarget.duration);
    const genresToShow = map(object.genres, 'name').join(', ');
    const description = compact([object.year, genresToShow, runTime]).join(', ');

    return { title, description, vastGenre, vastRating, objectTitle };
  }, [object, videoTarget, currentProgram]);

  useEffect(() => {
    const loadProgramData = async () => {
      try {
        const response = await requester({
          method: 'get',
          url: `${api.host}${api.endpoints.liveEvents}`,
          params: {
            'live.id[eq]': object.id,
            $expand: 'thumbnail(url),program,dvr,live',
            $limit: 1,
            'end_time[gt]': new Date().toISOString(),
          },
        });
        setCurrentProgram(get(response.data, [0]));
      } catch (error) {
        const message = get(error, ['response', 'data', 'error', 'message']) || error.message;
        console.error({ message });
      }
    };

    if (object?.type === 'channel') loadProgramData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [object?.id]);

  return result;
};
export default useMetadata;
